export const tva_RESET = "tva_RESET";
export const tva_SET_ERROR = "tva_SET_ERROR";
export const tva_SET_ITEMS = "tva_SET_ITEMS";
export const tva_TOGGLE_LOADING = "tva_TOGGLE_LOADING";
